import React, {useState, useEffect } from 'react'
import './aboutUs.css'

function About_us({language, reference}) {

    const [isSmallScreen, setIsSmallScreen] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1024);
        };
    
        // Initial check
        handleResize();
    
        // Listen for window resize event
        window.addEventListener('resize', handleResize);
    
        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    });

    const [mouseInsideDiv, setMouseInsideDiv] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const mouseEnteredDiv = () =>{
        setMouseInsideDiv(true);
    }

    const handleMouseMove = (e) => {
        if(mouseInsideDiv && !isSmallScreen){
            const rect = e.currentTarget.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const offsetY = e.clientY - rect.top;
            setMousePosition({ x: offsetX, y: offsetY });
        }
    };

    const handleMouseLeave = () => {
        setMouseInsideDiv(false);
        setMousePosition({ x: 0, y: 0 }); // Reset position when mouse leaves
    };

    const calculateTranslation = (imageId, factor) => {
        if (mouseInsideDiv) {
            const image = document.getElementById(imageId);
            const rect = image.getBoundingClientRect();
            const imageCenterX = rect.left + rect.width / 2;
            const imageCenterY = rect.top + rect.height / 2;

            const deltaX = mousePosition.x - imageCenterX;
            const deltaY = mousePosition.y - imageCenterY;

            return `translate(${deltaX / factor}px, ${deltaY / factor}px)`;
        } else {
            return 'translate(0px, 0px)';
        }
    };

    return (
        <section className='about_us_section' onMouseEnter={mouseEnteredDiv} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} ref={reference}>
            <div className='about_us_content'>
                <div className='about_us_text_box'>
                    <p style={{fontSize: '2rem'}}>{language === 'deutsch' ? 'Über uns' : 'About us'}</p>
                    <p>{language === 'deutsch' ?
                        'Wir bieten Ihnen vielfältige Dienstleistungen im Bereich der Arbeitssicherheit und der Ausbildung. Ob Staplerschulung oder Kranschulung, jährliche Mitarbeiterschulung oder Planung und Beratung im Bereich der Arbeitssicherheit. Dies alles ist nur ein kleiner Auszug aus unserem vielfältigen Angebot.' 
                        : 'We offer multiple services in the area of occupational safety and training. Whether forklift training or crane training, annual employee training or planning and advice in the areas of occupational safety. All of this is just a small excerpt from our diverse offering.'
                    }</p>
                </div>
                <div className='about_us_image_box'>
                    <img                         
                        src='res\img\equipment1.jpg' 
                        alt='equipment1' 
                        id='image1'
                        style={{
                            transform: mouseInsideDiv === true ? calculateTranslation('image1', 15) : `translate(0px, 0px)`, // Adjust the factor to control the movement amount
                        }}
                    />
                    <img 
                        src='res\img\equipment2.jpg' 
                        alt='equipment2' 
                        id='image2'
                        style={{
                            transform: mouseInsideDiv === true ? calculateTranslation('image2', 17) : `translate(0px, 0px)`, // Adjust the factor to control the movement amount
                        }}
                    />
                    <img 
                        src='res\img\equipment3.png' 
                        alt='equipment3' 
                        id='image3'
                        style={{
                            transform: mouseInsideDiv === true ? calculateTranslation('image1', 20) : `translate(0px, 0px)`, // Adjust the factor to control the movement amount
                        }}
                    />
                </div>
                <div className='about_us_image_box_mobile'>
                    <div className='top_images'>
                        <img                         
                            src='res\img\equipment1.jpg' 
                            alt='equipment1' 
                        />
                        <img 
                            src='res\img\equipment3.png' 
                            alt='equipment3' 
                        />
                    </div>
                    <img 
                        src='res\img\equipment2.jpg' 
                        alt='equipment2'
                        id='bottom_image'
                    />
                    
                </div>
            </div>
        </section>
    )
}

export default About_us